import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CurrencyFormat from 'react-currency-format';
import { DebounceInput } from 'react-debounce-input';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

class InputCurrencyCharge extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      formatValue: null
    };
    this.currencyInput = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) {
      return 'This field is required.';
    }
    for (const validator of validators || []) {
      if (validator(value)) {
        return validator(value);
      }
    }
    return '';
  };

  getFormatValue = (value, init) => {
    const { symbol } = this.props;
    const currencySymbol = symbol || 'USD';
    const floatValue = !Utils.isNull(value) ? parseFloat(value) : null;
    const fraction = !Utils.isNull(floatValue) ? floatValue.toString().split('.') : [];
    let minDecimalSize = 2;
    if (fraction.length > 1) {
      minDecimalSize = fraction[1].length > minDecimalSize ? fraction[1].length : minDecimalSize;
    }
    if (!init && !Utils.isNull(value) && this.currencyInput && this.currencyInput.current) {
      this.currencyInput.current.setState({
        value: parseFloat(value).toFixed(minDecimalSize).toString() + ' ' + currencySymbol,
        numAsString: parseFloat(value).toFixed(minDecimalSize).toString()
      });
    }
    return !Utils.isNull(value) ? parseFloat(value).toFixed(minDecimalSize).toString() : '';
  }

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    const { formatValue } = this.state;
    const floatValue = !Utils.isNull(formatValue) && !Utils.isNull(formatValue.floatValue) ? formatValue.floatValue : null;
    const formattedValue = !Utils.isNull(formatValue) && !Utils.isNull(formatValue.formattedValue) ? formatValue.formattedValue : null;
    this.setState({ value: floatValue });
    setTimeout(() => {
      this.getFormatValue(floatValue);
    }, 100);
    if (onChange) {
      onChange(floatValue?.toString());
    }
    const newError = this.validate(formattedValue);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  handleKeyDown = (e) => {
    const { onSubmit, value, min, max, maxlength, symbol } = this.props;
    const currencySymbol = symbol || 'USD';
    const maxCharacters = parseInt(maxlength) || 17;
    const integerSize = 10;
    const decimalSize = 6;
    if (![8,37,38,39,40,46,190].includes(e.keyCode)) {
      if (e.keyCode === 13) {
        if (onSubmit) {
          onSubmit();
        }
        e.preventDefault();
      } else {
        const idx = e.target.selectionStart;
        const number = !Utils.isNull(e.currentTarget.value) ? e.currentTarget.value.split(' '+currencySymbol) : [];
        const fraction = number.length ? number[0].split('.') : [];
        if (value && value.toString().length >= maxCharacters) {
          e.preventDefault();
        }
        if (fraction.length > 0 && idx <= fraction[0].length && fraction[0].length >= integerSize) {
          e.preventDefault();
        }
        if (fraction.length > 1 && idx > fraction[0].length && fraction[1].length >= decimalSize) {
          e.preventDefault();
        }
        if (Number(value) > Number(max)) {
          e.preventDefault();
          e.currentTarget.value = max;
        }
        if (e.currentTarget.value && Number(value) < Number(min)) {
          e.preventDefault();
          e.currentTarget.value = min;
        }
      }
    }
  };

  render() {
    const { className, label, labelhtml, error, placeholder, disabled, required, value, debounce, symbol } = this.props;

    const debounceTimeout = !Utils.isNull(debounce) ? debounce : 1000;

    const currencySymbol = symbol || 'USD';

    const valueFormatted = this.getFormatValue(value, true);

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required
    };

    return (
      <InputWrapper {...WrapperProps}>
        <DebounceInput
          debounceTimeout={debounceTimeout}
          element={CurrencyFormat}
          value={!Utils.isNull(valueFormatted) ? valueFormatted : ''}
          decimalScale={6}
          suffix={' ' + currencySymbol}
          onValueChange={(v) => this.setState({ formatValue: v })}
          disabled={disabled}
          required={required}
          onKeyDown={this.handleKeyDown}
          className={classNames('InputText', {
            InputText_Disabled: Boolean(disabled)
          })}
          placeholder={placeholder}
          onChange={this.handleChange}
          inputRef={this.currencyInput}
        />
      </InputWrapper>
    );
  }
}

InputCurrencyCharge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  symbol: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.number,
  maxlength: PropTypes.number,
  max: PropTypes.number,
  debounce: PropTypes.number,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func
};

export default withShallowComparison(InputCurrencyCharge, ['onChange', 'onError']);
